import { TextField } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { SketchPicker } from 'react-color';
import './Color-Picker.scss';

const ColorPicker = (props) => {
  const { title, onColorChange, backgroundColor, showColorPicker, setShowColorPicker } = props;
  const ref = useRef(null);
  const [background, setBackground] = useState(backgroundColor || '#8f8f8f');

  useEffect(() => {
    const onClickOutside = (event) => {
      if (ref?.current && !ref?.current?.contains(event?.target)) {
        if (showColorPicker) setShowColorPicker(false);
      }
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => {
      document.removeEventListener('mousedown', onClickOutside);
    };
  }, [ref]);

  const handleChangeComplete = (color) => {
    setBackground(color);
    onColorChange(color);
  };
  return (
    <div className='color-picker' ref={ref}>
      <div className='m-auto card shadow bg-white p-4'>
        <div className='mb-2 title'>{title ? title : 'Color Editor'}</div>
        <SketchPicker
          color={background}
          disableAlpha={true}
          onChangeComplete={(e) => handleChangeComplete(e.hex)}
        />
        {background && (
          <div className='px-2 mt-4 code d-flex align-items-center'>
            <div className='code-label'>Hex Code : </div>
            <div>
              <TextField
                className='col-md-6'
                value={background}
                onChange={(e) => handleChangeComplete(e.target.value)}
                inputProps={{ maxLength: 9 }}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ColorPicker;
